import { getAccessToken, refreshToken } from "Helpers/api";

let checkURL = "";
const urlhost = window.location.host;
if (urlhost.includes('ev.')) {
  checkURL = 'https://api.phishing-manager.dev.venzagrc.com';
}
if (urlhost.includes('tg.')) {
  checkURL = 'https://api.phishing-manager.stg.venzagrc.com';
}
if (!urlhost.includes('ev.') && !urlhost.includes('tg.') && !urlhost.includes(':8')) {
  checkURL = 'https://api.phishing-manager.prod.venzagrc.com';
}
const baseUrl = checkURL as string;

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getAccessToken()}`,
});

const authorizedFetch = async (
  url: string,
  options: RequestInit,
  retryCount = 0 
): Promise<Response> => {
  const response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });

  if (response.status === 401 && retryCount < 3) {
    try {
      await refreshToken();
      return authorizedFetch(url, options, retryCount + 1);
    } catch (err) {
      console.error("Token refresh failed:", err);
      throw err;
    }
  }
  return response;
};

export const getPhishingCampaignsForTenant = async (
  tenantId: string,
  page : number
) => {
  const url = `${baseUrl}/public/campaigns?venza_tenant_id=${tenantId}&page=${page}`;
  try {
    const response = await authorizedFetch(url, { method: "GET", headers: getAuthHeaders() });
    if (!response.ok) {
      throw new Error(`API call failed: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching provider list:", error);
    throw error;
  }
};

export const getPhishingCampaignsTemplatesForTenant = async (
  tenantId: string
) => {
  const url = `${baseUrl}/public/campaigns?venza_tenant_id=${tenantId}`;
  try {
    const response = await authorizedFetch(url, { method: "GET", headers: getAuthHeaders() });
    if (!response.ok) {
      throw new Error(`API call failed: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching provider list:", error);
    throw error;
  }
};

export const getPhishingCampaignData = async (
  tenantId: string
) => {
  const url = `${baseUrl}/public/tenants/${tenantId}/campaigns/threshold-summary`;
  try {
    const response = await authorizedFetch(url, { method: "GET", headers: getAuthHeaders() });
    if (!response.ok) {
      const errorBody = await response.json();
      throw {
        status: response.status,
        data: errorBody,
      };
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching provider list:", error);
    throw error;
  }
};
